import {GlobalVariables} from "../GlobalVariables";
import {Chart, ChartDataLabels} from "../LibrariesImport";
export default class BlockCharts {
	static init() {

		const blocks = document.querySelectorAll('.charts-container');
		blocks.forEach( block => {
			const charts = block.querySelector('.charts');
			const display = charts.dataset.display;
			const title = charts.dataset.title;
			const datas = block.querySelectorAll('.data');

			const labels = [];
			const values = [];
			const backgrounds = [];

			datas.forEach( data => {
				labels.push(data.dataset.label);
				values.push(parseFloat(data.dataset.value));
				backgrounds.push(data.dataset.background);
			});

			const myChart = new Chart(charts, {
				type: display, // 'pie', 'line', etc. sont aussi disponibles
				data: {
					labels: labels,
					datasets: [{
						data: values,
						backgroundColor: backgrounds
					}]
				},
				options: {
					responsive: true,
					maintainAspectRatio: false,
					cutout: '85%',
					plugins: {
						title: {
							display: true,
							text : title,
							font: {
								size: 18,
								weight: 'bold'
							},
							align: 'start',
							color: '#003C57'
						},
						legend: {
							display: false,
							position: 'chartArea'
						},
						layout: {
							padding: {
								top: 20,
								bottom: 20,
								left: 20,
								right: 20
							}
						},
						tooltip: {
							enabled: false
						},
						datalabels: {
							color: '#000',
							anchor: 'end',
							align: 'end',
							offset: 0,
							formatter: (value, context) => {
								const label = context.chart.data.labels[context.dataIndex];
								return `${value}% ${label}`;
							}
						}
					}
				}
			});
		});

	}

}
